<template>
  <div class="p-3 mx-auto" style="overflow: auto; height: 100%; max-width: 800px">
    <div id="edit-form">
      <div class="pagination mx-auto">
        <span :class="enabledPage[1] ? 'enable' : 'disable'"></span>
        <span :class="enabledPage[2] ? 'enable' : 'disable'"></span>
        <span :class="enabledPage[3] ? 'enable' : 'disable'"></span>
        <!-- <span :class="enabledPage[4] ? 'enable' : 'disable'"></span>
          <span :class="enabledPage[5] ? 'enable' : 'disable'"></span>
          <span :class="enabledPage[6] ? 'enable' : 'disable'"></span> -->
      </div>
      <div class="text-right">
        <button
          v-if="enabledPage[6] && numOfCompanyId % 2 === 1"
          @click="doLater"
          class="later-btn"
          >
        Do it later
        </button>
      </div>
      <div v-if="!isSaving">
        <!-- Step-1 -->
        <div class="px-2 mt-5" v-if="enabledPage[1]">
          <div class="mx-auto mt-4">
            <h4 class="text-center font-weight-bold">What would you like to do first in Howuku?</h4>
          </div>
          <div v-if="!isPass" class="alert alert-danger mt-3" role="alert">
            {{ errorMessage }}
          </div>
          <div 
            class="col-sm-10 firstTodo-border mt-4 mb-3 m-center" 
            @click="selectOption(firstTodoList[0], 'firstTodo')"
            :class="firstTodoList[0].isSelected ? 'btn-first' : ''"
            >
            <img
              src="../assets/img/journey.png"
              class="img-fluid float-left mr-3"
              :class="firstTodoList[0].isSelected ? 'img-white' : ''"
              style="margin-left: 4px"
              width="60"
              />
            <div class="mt-2 mb-2">
              <b style="line-height: 1.5; font-size: 16px;" for="inputWebsite" v-translate
                >Visualize user behaviour</b
                >
              <div class="small-font">
                {{ t("Heatmaps, Visitor Recordings, Visitor Journey") }}
              </div>
            </div>
          </div>
          <div 
            class="col-sm-10 firstTodo-border mb-3 m-center"
            @click="selectOption(firstTodoList[1], 'firstTodo')"
            :class="firstTodoList[1].isSelected ? 'btn-first' : ''"
            >
            <img
              src="../assets/img/data.png"
              class="img-fluid float-left mr-3"
              :class="firstTodoList[1].isSelected ? 'img-white' : ''"
              style="margin-left: 4px"
              width="60"
              />
            <div class="mt-2 mb-2">
              <b style="line-height: 1.5; font-size: 16px;" for="inputWebsite" v-translate
                >View trends with quantitative tools</b
                >
              <div class="small-font">
                {{ t("Funnels, Web & Form Analytics, Event Trackings") }}
              </div>
            </div>
          </div>
          <div 
            class="col-sm-10 firstTodo-border mb-3 m-center"
            @click="selectOption(firstTodoList[2], 'firstTodo')"
            :class="firstTodoList[2].isSelected ? 'btn-first' : ''"
            >
            <img
              src="../assets/img/positive-review.png"
              class="img-fluid float-left mr-3"
              :class="firstTodoList[2].isSelected ? 'img-white' : ''"
              style="margin-left: 4px"
              width="60"
              />
            <div class="mt-2 mb-2">
              <b style="line-height: 1.5; font-size: 16px;" for="inputWebsite" v-translate
                >Gather insights from users</b
                >
              <div class="small-font">
                {{ t("Onsite Survey, Feedback and A/B testing ") }}
              </div>
            </div>
          </div>
        </div>
        <!-- Step-2 -->
        <div class="px-2 mt-3" v-if="enabledPage[2]">
          <h4 class="font-weight-bold">Tell us about yourself</h4>
          <div v-if="!isPass" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>
          <div class="mt-2">
            <p class="font-weight-bold" v-translate>Your Role</p>
            <div class="option-grid">
              <div v-for="(item, i) in roleList"
                :key="i"
                @click="selectOption(item, 'role')"
                :class="item.isSelected ? 'option-box btn-first' : 'option-box'">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="mt-2 py-2">
            <p class="font-weight-bold">{{t('Do you have experience in installing user behaviour analytics tools?')}}</p>
            <div class="option-grid">
              <div v-for="(item, i) in installExp"
                :key="i"
                @click="selectOption(item, 'install_exp')"
                :class="item.isSelected ? 'option-box btn-first' : 'option-box'">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="mt-2 pb-2">
            <p class="font-weight-bold">{{t('Where did you know about us?')}}</p>
            <textarea
              v-model="knowFrom"
              placeholder="Please fill in some quick words"
              class="form-control"
              rows="3"
              ></textarea>
          </div>
        </div>
        <!-- Step-3 -->
        <div class="px-2 mt-3" v-if="enabledPage[3]">
          <h4 class="font-weight-bold">About your business</h4>
          <div v-if="!isPass" class="alert alert-danger mt-3" role="alert">
            {{ errorMessage }}
          </div>
          <div class="mt-2 pt-2">
            <div class="form-group">
              <label for="companyName" class="font-weight-bold mb-3">{{t('Company Name')}}</label>
              <input
                type="text"
                id="companyName"
                v-model="company_name"
                placeholder="e.g. My Company"
                class="company-icon form-control"
                />
            </div>
          </div>
          <div class="mt-2">
            <p class="font-weight-bold">{{t('Company Size')}}</p>
            <div class="option-grid">
              <div v-for="(item, i) in sizeList"
                :key="i"
                @click="selectOption(item, 'size')"
                :class="item.isSelected ? 'option-box btn-first' : 'option-box'">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="mt-2">
            <div class="form-group" style="width: 360px">
              <p class="font-weight-bold">{{t('Business Nature')}}</p>
              <div class="option-grid">
                <div v-for="(item, i) in businessNature"
                  :key="i"
                  @click="selectOption(item, 'business_nature')"
                  :class="item.isSelected ? 'option-box btn-first' : 'option-box'">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="mt-2 py-2">
            <div class="form-group">
              <label for="websiteURL" class="font-weight-bold mb-3">{{t('Website URL')}}</label>
              <input
                type="text"
                id="websiteURL"
                placeholder="e.g. www.example.com"
                v-model="websiteURL"
                class="web-icon form-control"
                />
            </div>
          </div>
        </div>
        <!-- Step-4 -->
        <!-- <div class="px-2 mt-4" v-if="enabledPage[4]">
          <h4 class="font-weight-bold">Invite your teammate</h4>
          <div v-if="!isPass" class="alert alert-danger mt-3" role="alert">
            {{ errorMessage }}
          </div>
          <div class="invite-team-grid">
            <div class="mt-4 py-2">
              <div class="form-group">
                <label for="workEmail" class="font-weight-bold mb-3">{{t('Work email')}}</label>
                <input
                  type="email"
                  id="workEmail"
                  placeholder="e.g. jane@example.com"
                  v-model="inviteEmail[0]"
                  class="user-icon form-control"
                />
                <input
                  type="email"
                  placeholder="e.g. doe@example.com"
                  v-model="inviteEmail[1]"
                  class="user-icon form-control mt-3"
                />
              </div>
              <p class="mb-0">By default, the team role will be set to "user". You can <br/>
                set up individual permission later.</p>
            </div>
            <div class="mt-4 ml-4 py-2">
              <img src="@/assets/img/team-invitation.png" alt="team-invitation">
            </div>
          </div>
          </div> -->
        <!-- Step-5 -->
        <!-- <div class="px-2 mt-5" v-if="enabledPage[5]">
          <h4 class="font-weight-bold">Enter your website</h4>
          <div v-if="!isPass" class="alert alert-danger mt-3" role="alert">
            {{ errorMessage }}
          </div>
          <div class="mt-4 py-2">
            <div class="form-group">
              <label for="websiteURL" class="font-weight-bold mb-3">{{t('Website URL')}}</label>
              <input
                type="text"
                id="websiteURL"
                placeholder="e.g. www.example.com"
                v-model="websiteURL"
                class="web-icon form-control"
              />
            </div>
          </div>
          <div class="mt-2">
            <p class="font-weight-bold">{{t('Average traffic per month')}}</p>
            <div class="option-grid">
              <div v-for="(item, i) in trafficList"
                   :key="i"
                   @click="selectOption(item, 'traffic')"
                   :class="item.isSelected ? 'option-box btn-first' : 'option-box'">
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="mt-4">
            <div class="form-group">
              <p class="font-weight-bold">{{t('Do you have experience in installing user behaviour analytics tools?')}}</p>
              <select class="custom-select" v-model="isNeededHelp" style="width: 360px">
                <option value="0" disabled selected>{{ t('No value selected') }}</option>
                <option value="1">{{ t('Yes, through HTML, WordPress, GTM, etc.') }}</option>
                <option value="2">{{t(`No, someone will install it for me`)}}</option>
                <option value="3">{{t(`No experience at all`)}}</option>
              </select>
            </div>
          </div>
          </div> -->
        <!-- Step-6 -->
        <!-- <div v-if="enabledPage[6]" class="mt-3">
          <InstallRecommendation :recommendPlugin="recommendPlugin"
                                 :selectedWidgetId="this.$session.get('widget_id')"
                                 isFirstLogin="true"
                                 @firstLoginPaging="showPaging = $event"
                                 @installComplete="setupComplete"/> -->
      </div>
      <!-- Paging Button -->
      <div class="paging-btn px-2" v-if="showPaging">
        <button v-if="!enabledPage[1]" @click="backPage" class="btn btn-muted">
        Back
        </button>
        <button
          v-if="enabledPage[4]"
          @click="doLater"
          class="btn-skip ml-auto"
          >
        <span style="font-weight: 600;">
        Skip
        </span>
        </button>
        <button v-if="!enabledPage[6] && !enabledPage[3]"
          @click="submit"
          class="btn btn-first ml-auto"
          v-bind:class="{ disabled: isSubmitted }"
          >
        <span v-if="!isSubmitted">Next</span>
        <span v-else>Processing...</span>
        </button>
        <button v-if=enabledPage[3]
          class="btn btn-first ml-auto"
          @click="submit"
          >
        <span v-if="!isSubmitted">Get Started</span>
        <span v-else>Processing...</span>
        </button>
        <button
          v-if="enabledPage[6] && numOfCompanyId % 2 === 0"
          @click="doLater"
          class="later-btn"
          >
        Do it later
        </button>
      </div>
    </div>
    <!-- Loading -->
    <div v-if="isSaving" class="px-2 mt-5">
      <Loading :message="loadingMessage" />
    </div>
  </div>
</template>
<script>
  import Loading from './Loading'
  import InstallRecommendation from './InstallRecommendation'
  import EmailValidator from 'email-validator'
  export default {
    name: 'FirstTimeLogin',
    components: {
      InstallRecommendation,
      Loading
    },
    props: {
      recommendPlugin: String,
      secretCode: String,
      selectedWidgetId: String,
      isNotAddWebsite: Boolean
    },
    data: () => ({
      numOfCompanyId: '',
      company_name: '',
      loadingMessage: '',
      isSubmitted: false,
      errorMessage: 'Please make sure to fill in all the details.',
      selectedRole: '',
      company_size: '',
      selectedTraffic: '',
      company_type: '',
      isNeededHelp: '',
      isPass: true,
      knowFrom: '',
      selectedFirstTodo: '',
      firstTodoList:[
        {name:'Visualize user behaviour', isSelected: false, value: 1},
        {name:'View trends with quantitative tools', isSelected: false, value: 2},
        {name:'Gather insights from users', isSelected: false, value: 3},
      ],
      roleList: [
        {name: 'C-Suite', isSelected: false, value: 1},
        {name: 'Digital Marketer', isSelected: false, value: 2},
        {name: 'Product Manager', isSelected: false, value: 3},
        {name: 'Store Owner', isSelected: false, value: 4},
        {name: 'UX Designer', isSelected: false, value: 5},
        {name: 'Web Developer', isSelected: false, value: 6},
        {name: 'Customer Success/Support', isSelected: false, value: 7},
        {name: 'Other', isSelected: false, value: 8}
      ],
      installExp: [
        {name: 'Yes, through GTM, WP, etc.', isSelected: false, value: 1},
        {name: 'Someone will install it for me', isSelected: false, value: 2},
        {name: 'No experience at all', isSelected: false, value: 3}
      ],
      sizeList: [
        // {name: '1 - 10 Employees', isSelected: false, value: 1},
        // {name: '11 - 50 Employees', isSelected: false, value: 2},
        // {name: '51 - 200 Employees', isSelected: false, value: 3},
        // {name: '201 - 1000 Employees', isSelected: false, value: 4},
        // {name: '1000+ Employees', isSelected: false, value: 5}
        {name: '1 - 50 Employees', isSelected: false, value: 1},
        {name: '51 - 500 Employees', isSelected: false, value: 2},
        {name: '500 + Employees', isSelected: false, value: 3}
      ],
      businessNature: [
        {name: 'E-commerce', isSelected: false, value: 1},
        {name: 'SaaS', isSelected: false, value: 2},
        {name: 'Digital Marketing Agency', isSelected: false, value: 3},
        {name: 'Blog or Personal', isSelected: false, value: 6},
        {name: 'Non-profit', isSelected: false, value: 9},
        {name: 'Other', isSelected: false, value: 10}
      ],
      trafficList: [
        {name: 'Up to 10k', isSelected: false, value: 1},
        {name: 'Up to 50k', isSelected: false, value: 2},
        {name: 'Up to 100k', isSelected: false, value: 3},
        {name: 'Up to 200k', isSelected: false, value: 4},
        {name: 'Up to 500k', isSelected: false, value: 5},
        {name: 'Not sure', isSelected: false, value: 6}
      ],
      inviteEmail: [],
      websiteURL: '',
      enabledPage: {
        1: true,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false
      },
      currentPage: 1,
      showPaging: true,
      recommendPlugin: '',
      isSaving: false,
      isSendEmail: true
    }),
    methods: {
      selectOption(option, type) {
        if (type === 'role') {
          if (this.selectedRole) this.selectedRole.isSelected = false
          this.selectedRole = option
        } else if (type === 'size') {
          if (this.company_size) this.company_size.isSelected = false
          this.company_size = option
        } else if (type === 'traffic') {
          if (this.selectedTraffic) this.selectedTraffic.isSelected = false
          this.selectedTraffic = option
        } else if (type === 'firstTodo') {
          if (this.selectedFirstTodo) this.selectedFirstTodo.isSelected = false
          this.selectedFirstTodo= option
        } else if (type === 'install_exp') {
          if (this.isNeededHelp) this.isNeededHelp.isSelected = false
          this.isNeededHelp = option
        } else if (type === 'business_nature') {
          if (this.company_type) this.company_type.isSelected = false
          this.company_type = option
        }
        option.isSelected = true
      },
      setupComplete() {
        this.isSaving = true
        this.loadingMessage = 'Saving your info...'
        // save to database
        let data = {
          fisrt_todo: this.selectedFirstTodo.value,
          current_position: this.selectedRole.value,
          know_from: this.knowFrom,
          company_name: this.company_name,
          company_type: this.company_type.value,
          company_size: this.company_size.value,
          widget_allowed_website: this.websiteURL,
          monthly_average_traffic: this.selectedTraffic.value,
          install_exp: this.isNeededHelp.value,
          widget_id: this.$session.get('widget_id')
        }
        this.$http.post(process.env.API_ENDPOINT + '/saveFirstLogin', data)
          .then((response) => {
            // send invitation email
            if (this.inviteEmail.length > 0 && this.isSendEmail) {
              this.loadingMessage = 'Sending invitation email...'
              this.inviteEmail.forEach((email) => {
                this.$http
                  .post(process.env.API_ENDPOINT + '/invite/user', {
                    email: email,
                    user_id: this.$session.get('user_id'),
                    role: 2, // user
                    isOptimize: this.$isOptimize
                  })
                  .then(() => {
                    this.isSaving = false
                    this.$swal.fire({
                      title: 'Setup complete',
                      text:
                        'We successfully saved your info and sent the invitation. You can start using Howuku now.',
                      type: 'success',
                      confirmButtonColor: 'rgba(var(--main-color),1)'
                    })
                      .then(() => {
                        this.$session.set('first_login', 'no')
                        this.$modal.hide('show-first-login')
                        window.location.reload()
                      })
                  })
                  .catch((err) => {
                    console.log(err, 'send invite')
                    this.isSaving = false
                    this.$swal.fire({
                      title: 'Failed to send invitation',
                      text:
                        'We were not able to send an invitation to ' + email + '.',
                      type: 'error',
                      confirmButtonColor: 'rgba(var(--main-color),1)'
                    }).then(() => {
                      this.enabledPage[this.currentPage] = false
                      this.currentPage = 4
                      this.enabledPage[this.currentPage] = true
                    })
                  })
              })
            } else {
              this.isSaving = false
              // this.$swal.fire({
              //   title: 'Setup complete',
              //   text:
              //     'Your info has successfully saved. You can start using Howuku now.',
              //   type: 'success',
              //   confirmButtonColor: 'rgba(var(--main-color),1)'
              // })
                // .then(() => {
              this.$session.set('first_login', 'no')
              this.$modal.hide('show-first-login')
              window.location.reload()
                // })
            }
          })
          .catch((err) => {
            console.log(err, 'save setup')
            this.$swal.fire({
              title: 'Failed to setup',
              text:
                'Something wrong happened. Check your info again or contact our admin.',
              type: 'error',
              confirmButtonColor: 'rgba(var(--main-color),1)'
            })
          })
      },
      showGuide(layout, plugin) {
        this.toLayout = layout
        if (plugin) this.guidePlugin = plugin
        this.enabledPage[this.currentPage] = false
        this.currentPage++
        this.enabledPage[this.currentPage] = true
      },
      openLink(url) {
        window.open(url, '_blank')
      },
      backPage() {
        // reset error handling
        this.isPass = true
        this.errorMessage = 'Please make sure to fill in all the details.'
        this.enabledPage[this.currentPage] = false
        this.currentPage--
        this.enabledPage[this.currentPage] = true
      },
      doLater() {
        if (this.enabledPage[6]) {
          this.$swal
            .fire({
              title: 'Are you sure?',
              text: "You won't be able to start using Howuku until you install the tracking code.",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: 'rgba(var(--main-color),1)',
              cancelButtonColor: '#dcdcdc',
              confirmButtonText: 'Install Now',
              cancelButtonText: 'Continue without installing'
            })
            .then((result) => {
              if (!result.value) this.setupComplete()
            })
        } else {
          this.isSendEmail = false
          this.nextPage()
        }
      },
      isURL(str) {
        var pattern = new RegExp(
          '[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,9}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)|localhost',
          'ig'
        )
        return pattern.test(str)
      },
      validURL(s, protocols) {
        try {
          let url = new URL(s)
          return protocols
            ? url.protocol
              ? protocols.map(x => `${x.toLowerCase()}:`).includes(url.protocol)
              : false
            : true
        } catch (err) {
          return false
        }
      },
      submit() {
        // STEP 1-2
        if ((this.currentPage === 1 && this.selectedFirstTodo) ||
            (this.currentPage === 2 && this.selectedRole && this.knowFrom)) {
          this.isPass = true
          this.nextPage()
        // STEP 3
        } else if (this.currentPage === 3 && this.company_type && this.company_size && this.company_name) {
          this.isSubmitted = true
          if (this.websiteURL) {
            // remove params
            let tempURL = this.websiteURL
            tempURL = tempURL.split('?')[0]
            // auto-assign protocol if not exist
            if (!this.validURL(tempURL, ['http', 'https'])) tempURL = 'https://' + tempURL
            if (this.isURL(tempURL)) {
              this.websiteURL = tempURL
              // website CMS check
              let data = {
                websiteURL: this.websiteURL
              }
              this.$http.post(process.env.API_ENDPOINT + '/checkWebsite', data)
                .then((response) => {
                  data = {
                    widget_allowed_website: this.websiteURL,
                    widget_id: this.$session.get('widget_id'),
                    monthly_average_traffic: this.selectedTraffic.value
                  }
                  this.recommendPlugin = response.data
                  this.$http.post(process.env.API_ENDPOINT + '/saveWidget', data)
                    .then((response) => {
                    this.isPass = true
                    this.isSubmitted = false
                    // this.nextPage()
                    this.setupComplete()
                    })
                    .catch((err) => {
                      console.log(err)
                      setTimeout(() => {
                        this.$modal.hide('show-first-login')
                      }, 2000)
                    })
                })
                .catch((err) => {
                  this.isPass = false
                  this.isSubmitted = false
                  this.errorMessage = 'Error checking website CMS'
                  console.log(err)
                })
            } else {
              this.isPass = false
              this.isSubmitted = false
              this.errorMessage = 'Invalid website URL format'
            }
          } else {
            this.isSubmitted = false
            this.isPass = false
          }
        // STEP-4
        } else if (this.currentPage === 4) {
          if (this.inviteEmail.length > 0) {
            this.isSendEmail = true
            for (let i = 0; i < this.inviteEmail.length; i++) {
              if (this.inviteEmail[i]) {
                if (!EmailValidator.validate(this.inviteEmail[i])) {
                  this.isPass = false
                  this.errorMessage = 'Invalid email format'
                  break
                } else if (this.$session.get('email') === this.inviteEmail[i]) {
                  this.isPass = false
                  this.errorMessage = 'You cannot invite yourself'
                  break
                }
                let data = {
                  email: this.inviteEmail[i]
                }
                this.$http.post(process.env.API_ENDPOINT + '/checkDuplicateEmail', data)
                  .then((response) => {
                    if (response.data.err) {
                      this.isPass = false
                      this.errorMessage = response.data.err
                    } else {
                      this.isPass = true
                      this.nextPage()
                    }
                  })
                  .catch((err) => {
                    console.log(err, 'check email')
                    this.isPass = false
                    this.errorMessage = 'Error checking your email'
                  })
              } else {
                this.isPass = true
                this.nextPage()
              }
            }
          } else this.nextPage()
        // STEP-5
        } else if (this.currentPage === 5) {
          this.isSubmitted = true
          if (this.websiteURL && this.selectedTraffic && this.isNeededHelp) {
            // remove params
            let tempURL = this.websiteURL
            tempURL = tempURL.split('?')[0]
            // auto-assign protocol if not exist
            if (!this.validURL(tempURL, ['http', 'https'])) tempURL = 'https://' + tempURL
            if (this.isURL(tempURL)) {
              this.websiteURL = tempURL
              // website CMS check
              let data = {
                websiteURL: this.websiteURL
              }
              this.$http.post(process.env.API_ENDPOINT + '/checkWebsite', data)
                .then((response) => {
                  data = {
                    widget_allowed_website: this.websiteURL,
                    widget_id: this.$session.get('widget_id'),
                    monthly_average_traffic: this.selectedTraffic.value
                  }
                  this.recommendPlugin = response.data
                  this.$http.post(process.env.API_ENDPOINT + '/saveWidget', data).then((response) => {
                    this.isPass = true
                    this.isSubmitted = false
                    this.nextPage()
                  })
                })
                .catch((err) => {
                  this.isPass = false
                  this.isSubmitted = false
                  this.errorMessage = 'Error checking website CMS'
                  console.log(err)
                })
            } else {
              this.isPass = false
              this.isSubmitted = false
              this.errorMessage = 'Invalid website URL format'
            }
          } else {
            this.isSubmitted = false
            this.isPass = false
          }
        } else {
          this.isSubmitted = false
          this.isPass = false
        }
      },
      nextPage() {
        // reset error handling
        this.isPass = true
        this.errorMessage = 'Please make sure to fill in all the details.'
        this.enabledPage[this.currentPage] = false
        this.currentPage++
        this.enabledPage[this.currentPage] = true
      }
    },
    async mounted() {
      this.numOfCompanyId = this.$session.get('company_id')
    }
  }
</script>
<style scoped>
  .m-center {
  margin-left: auto;
  margin-right: auto;
  }
  .img-white {
  filter: saturate(500%) contrast(800%) brightness(500%) invert(80%) sepia(50%) hue-rotate(120deg);
  }
  .small-font {
  font-size: 14px;
  }
  .paging-btn {
  margin-top: 20px;
  margin-bottom: 0px;
  display: flex;
  justify-content: space-between;
  }
  .invite-team-grid {
  display: inline-grid;
  grid-template-columns: auto auto;
  margin-bottom: 15px;
  width: 100%;
  }
  .option-grid {
  display: inline-grid;
  grid-template-columns: auto auto auto;
  grid-gap: 20px;
  margin-bottom: 15px;
  }
  .option-box {
  text-align: center;
  border-radius: 10px;
  padding: 15px 0px;
  width: 232px;
  border: 1px solid rgb(222, 227, 227);
  box-shadow: rgb(0 0 0 / 8%) 0px 4px 12px;
  cursor: pointer;
  }
  .later-btn{
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  color: #7a7a7a;
  font-size: 13px;
  }
  .text-center {
  text-align:center;
  }
  .text-right {
  text-align:end;
  }
  .pagination{
  display:flex;
  width: 85px;
  }
  .pagination .disable {
  width: 20px;
  height: 5px;
  border-radius: 999px;
  background: rgba(var(--main-color),1);
  cursor: pointer;
  transition: 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffff;
  padding: 5px;
  margin: 0px 5px;
  }
  .pagination .enable{
  width: 100%;
  height: 5px;
  border-radius: 999px;
  background: rgba(var(--main-color),1);
  cursor: pointer;
  transition: 0.25s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffff;
  padding: 5px;
  margin: 0px 5px;
  }
  .firstTodo-border {
  /*border: 1px solid black;*/
  border: 1px solid rgb(228, 232, 235);
  box-shadow: rgb(0 0 0 / 8%) 0px 4px 12px;
  border-radius: 10px;
  padding: 20px;
  height: auto;
  font-size: 110%;
  }
  .firstTodo-border:hover {
  cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/FirstTimeLogin.vue